import { PARTNERS } from './partners';

/**
 * Partners, whose offers can be solicited.
 * @type {Array}
 */
export const SOLICITATION_SUPPORTED_PARTNERS = [
  PARTNERS.CARMAX,
  PARTNERS.ECHOPARK,
  PARTNERS.ICO,
  PARTNERS.PLUG,
  PARTNERS.DRIVEWAY,
];
